<template>
  <div>
    <div class="flex justify-between">
      <label
        v-if="label"
        v-text="label"
        :for="$id('basic-input')"
        class="block text-sm font-medium leading-5 text-gray-700"
      />
      <span v-if="cornerHint" class="text-sm leading-5 text-gray-500" v-text="cornerHint"></span>
    </div>

    <div class="mt-1 relative rounded-md shadow-sm">
      <flat-pickr
        :id="$id('basic-input')"
        v-bind="inputAttrs"
        v-on="inputListeners"
        :config="mergedConfig"
        class="form-input block w-full sm:text-sm sm:leading-5 disabled:opacity-50 disabled:bg-gray-100 pr-7"
        :disabled="disabled"
      ></flat-pickr>

      <div v-if="!disabled" class="absolute inset-y-0 right-0 pr-3 flex items-center">
        <button
          tabindex="-1"
          class="flex item-center"
          @click="$emit('input', null)"
          v-if="$attrs.value"
        >
          <font-awesome-icon :icon="['far', 'times']" class="text-gray-600" />
        </button>
      </div>
    </div>

    <p class="mt-2 text-sm text-red-600" v-if="hasError" v-text="error[0]" />
  </div>
</template>

<script>
import moment from "moment-timezone";
import dayjs from "dayjs";

export default {
  inheritAttrs: false,

  props: {
    label: {
      required: false,
      type: String,
    },
    cornerHint: {
      required: false,
      type: String,
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean,
    },
    config: {
      required: false,
      default: () => {},
      type: Object,
    },
    format: {
      required: false,
      default: "l, d.m.Y H:i",
      type: String,
    },
    error: {
      required: false,
      default: null,
    },
  },

  methods: {
    convertTimezone(value, from, to) {
      return value
        ? moment.tz(value, from).tz(to).format("YYYY-MM-DD HH:mm:ss")
        : null;
    },
  },

  computed: {
    hasError() {
      return !!this.error;
    },
    mergedConfig() {
      return {
        enableTime: true,
        altFormat: this.format,
        altInput: true,
        dateFormat: "Y-m-d H:i:S",
        ...this.config,
      };
    },
    inputAttrs: function () {
      return Object.assign({}, this.$attrs, {
        value: this.convertTimezone(
          this.$attrs.value,
          "UTC",
          "Europe/Amsterdam"
        ),
      });
    },
    inputListeners: function () {
      return Object.assign({}, this.$listeners, {
        // This ensures that the component works with timezones
        input: (event) => {
          this.$emit(
            "input",
            this.convertTimezone(event, "Europe/Amsterdam", "UTC")
          );
        },
      });
    },
  },
};
</script>